import React, { useEffect, useState } from "react";
import { Image, View, ScrollView, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux'

import Header from "../../../components/Header";
import { userSignIn } from '../../../action';
import { CheckComponent } from "../../../components";
import { openLink, checkCookie } from "../../../functions";
import styles from "../../../styles";
import { global, action, colors } from '../../../const'
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { forgot_ic } from '../../../assets'
import { localStorage } from "../../../functions/AsyncStorage";
import { PrimaryTitle, InputAlertTitle, LinkIndigo } from "../../../components/labels";
import { TextInput, PasswordInput, Button } from "../../../components/form";
import localize from "../../../localize";

function SignIn(props) {
    const dispatch = useDispatch();
    const isRemember = useSelector(({ auth }) => auth.isRemember)

    const [state, setState] = useState({
        passowrdStatus: true,
        username: '',   // chengxm1218
        password: '',   // 19931218cxm
        errorMessage: null,
        passwordMessage: null,
        error: null,
        redirect: 'dashboard',
    })

    // useEffect(() => {
    //     window.document.title = global.app_code === "dv" ? localize.Daily_Vitals_powered_by_Woogi : localize.English_Vitals_powered_by_Woogi;
    // }, [])

    const onSignIn = async () => {
        dispatch({ type: action.LOADING_DIALOG_TRUE });
        setState({ ...state, error: null })
        let result = await dispatch(userSignIn({ name: state.username, password: state.password }));
        dispatch({ type: action.LOADING_DIALOG_FALSE });
        if (result.status === 200 || result.status === 201) {
            window.socket();
            let pathname = "/Add-Bookmark";
            if (global.APP_PLATFORM() === "ios" || global.APP_PLATFORM() === "and") {
                pathname = "/open-native-app";
            }
            if (checkCookie(global.IS_BOOKMARK_ADDED)) {
                pathname = "/dashboard";
            }
            return props.history.push({ pathname })
        }
        setState({ ...state, error: result.message })
    }

    const _clearLogin = () => {
        localStorage(4)
        setState({ ...state, username: "", password: "" })
    }

    return (
        <View style={styles.container}>
            <Header title={localize.Sign_In} goBack={() => props.history.push("/")} />
            <ScrollView keyboardShouldPersistTaps="always" style={{ paddingHorizontal: 20 }}>

                <View style={{ paddingTop: 50 }}>
                    <PrimaryTitle>
                        {localize.Sign_in_with_your_Woogi_Connect_or_Woogi_Create_user_name}
                    </PrimaryTitle>
                </View>
                <View style={{ padding: 20 }} />
                <TextInput
                    title={localize.user_name}
                    placeholder={localize.name_}
                    value={state.username}
                    onChangeText={(text) => setState({ ...state, username: text })}
                    error={state.errorMessage}
                    right={state.username !== '' && (
                        <Icon
                            icon={faCheck}
                            color={colors.green}
                            style={{ position: "static", fontSize: 20 }}
                        />
                    )}
                />

                <View style={{ padding: 8 }} />
                <PasswordInput
                    title={localize.password}
                    placeholder={localize.password}
                    value={state.password}
                    onChangeText={(text) => setState({ ...state, password: text })}
                    error={state.passwordMessage}
                    progressVisible={false}
                    onSubmitEditing={onSignIn}
                />



                <TouchableOpacity
                    style={{ flexDirection: 'row', marginTop: global.isNative ? -12 : 6 }}
                    onPress={() => openLink(global.FORGOTPASSWORD_URL)}
                >
                    <Image
                        source={forgot_ic}
                        style={{ width: 12, height: 12, marginRight: 5, marginTop: 2 }}
                        resizeMode="contain"
                    />

                    <Text style={pageStyles.forgotTitle}>{localize.FORGOT_PASSWORD}</Text>

                </TouchableOpacity>

                <View style={{ marginTop: 10 }} />

                {
                    !window.wv && (
                        <View style={[styles.checkboxRow, { marginTop: 20, marginBottom: 20 }]}>

                            <CheckComponent
                                checked={isRemember}
                                onPress={() => dispatch({ type: action.IS_REMEMBER_ME })}
                                style={{ paddingRight: 5 }}
                            />
                            <PrimaryTitle size={15} color={colors.indigo}>
                                {localize.Automatic_login}
                            </PrimaryTitle>

                        </View>
                    )
                }
                <InputAlertTitle>
                    {state.error}
                </InputAlertTitle>
                <View style={{ padding: 5 }} />
                <Button
                    title={localize.SIGN_IN}
                    disabled={state.password === '' || state.username === '' ? true : false}
                    onPress={onSignIn}
                />
                <TouchableOpacity
                    style={pageStyles.link}
                    onPress={_clearLogin}
                >
                    <LinkIndigo>
                        {localize.Clear_login_and_password}
                    </LinkIndigo>
                </TouchableOpacity>
            </ScrollView>
        </View>
    )

}

export default SignIn;

const pageStyles = StyleSheet.create({
    forgotTitle: {
        color: '#4d5a70',
        fontSize: 12,
        fontWeight: "bold",
        fontFamily: 'NotoSans-Bold'
    },
    link: {
        alignSelf: "center",
        marginVertical: 30,
        marginHorizontal: 20
    },
    textboxIcon: {
        height: 18,
        width: 18,
        resizeMode: "contain"
    }
})